import * as React from 'react';
import { css } from 'aphrodite/no-important';
import { getSectionStyle, MaxWidthValues } from '../pageLayouts/layout.utils';

interface SectionWithTitleProps {
  maxWidth?: MaxWidthValues;
}

export const SectionWithTitle: React.FunctionComponent<SectionWithTitleProps> = props => {
  const { maxWidth, children } = props;
  const sectionStyle = getSectionStyle(maxWidth);

  return (
    <section className={css(sectionStyle)}>
      {children}
    </section>
  );
};
